module.exports = __webpack_public_path__ + "assets/img/shouhou.c6440d9d.png";